import React, { useEffect, useState } from 'react'; // useEffectとuseStateをインポート
import { Helmet } from 'react-helmet-async'; // ★これと
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import HighSchoolIntroduction from "./HighSchoolIntroduction";
import SupportPointHighSchool from "./SupportPointHighSchool";
import CourceHighSchool from "./CourceHighSchool";
import QuestionHighSchool from "./QuestionHighSchool";

const Container = styled.div`
    width: 100%;
    margin: auto;
    margin-top: 170px;
    text-align: center;
    @media ${device.mobile} {
        margin-top: 80px;
    }
`;


const MainBackColorGradient = styled.div`
background: linear-gradient(
  to bottom, 
  rgba(155, 0, 63, 1) 0%,   /* 上：赤（不透明） */
  rgba(255, 69, 0, 0.7) 50%, /* 中間：orangered（半透明） */
  rgba(255, 69, 0, 0) 100%   /* 下：orangered（完全透明） */
);
`;

// ▲▲▲ 追加：お知らせ用のスタイルここまで ▲▲▲
const TosayobiHighSchool = () => {
    // アニメーションクラスを適用するかどうかを管理するstate
    const [animate, setAnimate] = useState(false); // コンポーネントがマウントされた（表示された）ときにアニメーションをトリガー
    useEffect(() => {
        // 画面に表示されたことを感知したらanimateをtrueにする
        setAnimate(true);
    }, []); // 空の依存配列は、コンポーネントが初回マウントされた時のみ実行されることを意味する
    return (
        <Container>
            {/* ★ここからHelmetの記述を追加します */}
            <Helmet>
                <title>TOSAYOBI高等学院 | 高知の通信制高校</title> {/* ←ここに希望するタイトルを設定 */}
                <meta name="description" content="TOSAYOBI高等学院の公式ウェブサイトです。高知で通信制高校をお探しの方へ。" />
                {/* 必要であれば、OGPタグなどもここに追加できます */}
                <meta property="og:title" content="TOSAYOBI高等学院" />
                <meta property="og:description" content="高知県で大学受験対策もできる通信制高校をお探しならTOSAYOBI高等学院。土佐塾予備校のノウハウで、一人ひとりに寄り添い高卒資格と志望大学合格をサポートします。" />
                <meta property="og:keywords" content="高知,予備校,入試,通信制" />
                {/* <meta property="og:image" content="ここにOGP画像のURL" /> */}
            </Helmet>
            {/* TOSAYOBI高等学院とは 土佐塾予備校 × 第一学院高等学校 まで */}


            <HighSchoolIntroduction />
        </Container >
    );
};

export default TosayobiHighSchool;
